/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useLocation, Link } from "react-router-dom";
import { Navigation, SVGIcon } from "@nordcloud/gnui";
import { ROUTES } from "~/routing";

function ServiceCommitmentsNavigation() {
  const location = useLocation();
  const isActive = (check: string) => location.pathname === check;
  const params = (to: string) => ({
    as: Link,
    to,
    className: `hasBg ${isActive(to) && "active"}`,
  });

  const MENU_ITEMS = [
    {
      label: "Service List",
      link: `${ROUTES.serviceCommitments.index}`,
    },
    {
      label: "Service Groups",
      link: `${ROUTES.serviceGroups.index}`,
    },
  ] as const;

  return (
    <Navigation.Container secondary>
      {MENU_ITEMS.map((item) => (
        <Navigation.Item key={item.link} {...params(item.link)}>
          {item.label} <SVGIcon name="arrowRight" />
        </Navigation.Item>
      ))}
    </Navigation.Container>
  );
}

export default ServiceCommitmentsNavigation;
